import React from 'react';
import {
  compose,
  withPropsOnChange,
  withHandlers,
  mapProps,
  withState,
} from 'recompose';
import { v4 as uuidv4 } from 'uuid';

// Clickable Menus
export const withMenuOnClickContainer = compose(
  withState('visibleMenu', 'setMenu', null),
  withHandlers(() => ({
    hideMenu:
      ({ setMenu }) =>
      () => {
        setMenu(null);
      },
  })),
);

export const withMenuOnClickItem = compose(
  withPropsOnChange(
    ['menu', 'visibleMenu', 'setMenu'],
    ({ menu, menuKey, visibleMenu, setMenu, hideMenu }) => {
      if (!menu) {
        return {};
      }

      // These props are passed to each SideNav Icon
      const uuid = uuidv4();
      return {
        isMenuVisible: visibleMenu?.key === menuKey,
        'data-menu-target': uuid,
        onClick: e => {
          if (visibleMenu?.key === menuKey) {
            return hideMenu();
          }

          const hasMenuTarget = e.target.getAttribute('data-menu-target');
          const target =
            (!hasMenuTarget &&
              e.target.closest(`[data-menu-target="${uuid}"]`)) ||
            e.target;
          return setMenu(
            // These props are passed to the Menu itself
            React.cloneElement(menu, {
              key: menuKey,
              anchorEl: target,
              hideMenu,
            }),
          );
        },
      };
    },
  ),
  mapProps(({ menu, menuKey, visibleMenu, setMenu, ...restProps }) => ({
    ...restProps,
  })),
);
